import { HandsontableCellType } from 'SharedDir/constants/field-types';
import { TableColumnType } from 'SharedDir/declarations/fields';

export default class TableColumn implements TableColumnType {
  slug!: string;

  order: number = 0;

  type: HandsontableCellType = HandsontableCellType.numeric;

  isSummary!: boolean;

  catalogSlug!: string | null;

  catalogColumnSlug!: string | null;

  summedColumns?: undefined | Array<string>;

  constructor({
    slug,
    order,
    isSummary,
    summedColumns,
    type,
    catalogColumnSlug,
    catalogSlug,
  }: Partial<TableColumnType> = {}) {
    this.slug = slug || '';
    if (order) {
      this.order = order;
    }
    this.isSummary = isSummary || false;
    if (this.isSummary) {
      this.summedColumns = summedColumns || undefined;
    } else {
      this.summedColumns = [];
    }
    this.type = type || HandsontableCellType.text;

    this.catalogSlug = catalogSlug || null;
    this.catalogColumnSlug = catalogColumnSlug || null;
  }
}
